
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private get c() {
    return this.data;
  }
  //   private set c(val) {
  //     console.log("111");
  //     this.$emit("update:content", val);
  //   }
  private radioClick(ev: any) {
    if (!this.ifCompose) {
      return;
    }
    this.c.value === ev ? (this.c.value = "") : (this.c.value = ev);
    this.$emit("update", this.c);
    this.changeHide();
  }
  /**
   * @description 题目联动
   */
  private changeHide() {
    console.log('联动')
    // 有control字段才需要联动
    if (!this.c.control) {
      return;
    }
    const data = this.c;
    if (this.c.type === "单选" || this.c.type === "下拉单选") {
      let index;
      this.c.options.forEach((ele: any, i: any) => {
        if (ele === this.c.value) {
          index = i;
        }
      });
      if (this.c.value) {
        data.control.index = [index];
      } else {
        data.control.index = [];
      }
    } else if (this.c.type === "计分单选" || this.c.type === "sf36计分单选") {
      let index;
      this.c.options.forEach((ele: any, i: any) => {
        if (ele.name === this.c.value.name) {
          index = i;
        }
      });
      if (this.c.value && this.c.value.name) {
        data.control.index = [index];
      } else {
        data.control.index = [];
      }
    } else if (this.c.type === "单选补充文字") {
      let index;
      let hasVal = false;
      this.c.options.forEach((ele: any, i: any) => {
        if (ele.value) {
          index = i;
          hasVal = true;
        }
      });
      if (hasVal) {
        data.control.index = [index];
      } else {
        data.control.index = [];
      }
    } else if (this.c.type === "多选") {
      const indexs: any = [];
      this.c.value.forEach((ele: any) => {
        this.c.options.forEach((item: any, i: any) => {
          if (ele === item) {
            indexs.push(i);
          }
        });
      });
      if (indexs.length > 0) {
        data.control.index = indexs;
      } else {
        data.control.index = [];
      }
    } else if (this.c.type === "多选补充文字") {
      const indexs: any = [];
      this.c.options.forEach((ele: any, i: any) => {
        if (ele.value) {
          indexs.push(i);
        }
      });
      if (indexs.length > 0) {
        data.control.index = indexs;
      } else {
        data.control.index = [];
      }
    }
    console.log(data);
    this.$emit("changeHide", data);
  }
}
